
angular.module('mtic.components.dashboards.teacher_general').component('teacherClassesStudentsReturn', {
  templateUrl: 'template.html',
  bindings: {
    school: '<'
  },
  controllerAs: 'table',
  controller($q, $log, TeacherDataService, MticAlertModalService) {

    var table = this;

    var validator = Validator.validator();

    var is = Validator.Assert;

    table.flags = {
      loading: true,
      error: null,
      reset: function() {
        this.loading = true;
        this.error = null;
      },
      done: function(error) {
        this.loading = false;
        if(error) {
          this.error = error;
        }
      }
    }

    table.options = {
      transferProgress: true
    }

    table.classes = {
      list: [],
      selected: null
    }

    table.students = {
      searchText: '',
      searched: false,
      found: [],
      selected: null,
      search : function(studentUserName) {
        return TeacherDataService.searchStudent({
          uuid: studentUserName,
          noschool: true,
          auth_type: 'microsoftStrategy'
        })
        .then( function(students) {
          table.students.found = students;
          table.students.searched = true;
        });
      },
      select: function(student) {
        table.students.selected = student;
      },
      addToClass: function() {
        var student = table.students.selected;
        var classroom = table.classes.selected;
        if(student.moduleResource.id === classroom.module_resource_id) {
          return TeacherDataService.transferStudent({
            user_id: student.user_id,
            from_class_id: student.classroom.id,
            to_class_id: classroom.id,
            transferProgress: table.options.transferProgress
          }).
          then( function(response) {
            $log.debug({response})
             MticAlertModalService.set('Succesfuly Transfered!', {isLang:false})
          } ).
          catch( function(err) {
            $log.debug(err)
             MticAlertModalService.set('Something happend!', {isLang:false})
          } )
        }
        else{
          var msg = 'Transfering this student to this class will mean that their work will not be moved (since the previous class had access to different resources)';
          MticAlertModalService.set(msg, {
            isLang: false,
            ask: true,
            callback(saidYes) {
              if(saidYes) {
                return TeacherDataService.transferStudent({
                  user_id: student.user_id,
                  class_id: classroom.id,
                  transferProgress: false
                });
              }
            }
          })
        }
      }
    }

    var getClasses = function(school_id, reset) {
      return TeacherDataService.getSchoolClasses(reset, school_id, false).
      then(function(classes) {
        table.classes.list = classes;
        table.classes.selected = classes[0]
        return;
      })
    }

    var updateSelections = function(reset) {
      $log.debug('school', table.school)
      var selectedSchool = table.school;
      $log.debug({selectedSchool})
      table.flags.reset();

      return getClasses(selectedSchool.id, reset)
      .then( function(){
        table.flags.done()
      });
    }

    table.$onInit = function() {
      updateSelections()
    };

    table.$onChanges = function() {
      updateSelections()
    };

  }
})
